import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformancePIPDetailPage from "@/pages/admin/PerformancePIPDetailPage";

export const Route = createFileRoute("/_admin/admin/performance/pip/$pipId")({
  head: () => pageHead("Admin · Performance · Pip", "AKIVA admin · performance · pip portal.", "/admin/performance/pip/$pipId", true),
  component: PerformancePIPDetailPage,
});
